import Icons20x20 from '~/UI/CountryIcon/icons-20x20';
import Icons40x40 from '~/UI/CountryIcon/icons-40x40';

export default class Country {
	alpha2: keyof typeof Icons20x20 | keyof typeof Icons40x40;

	name: string;

	constructor(alpha2: string, name: string) {
		this.alpha2 = alpha2 as keyof typeof Icons20x20 | keyof typeof Icons40x40;
		this.name = name;
	}
}
